import styled from "styled-components";

const ModalCreateStyle = styled.div`
.boxInputCenter{
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 10px;
}

`
export { ModalCreateStyle }


const CustomTitleModalStyle = styled.div`
.BoxTitle{
    color: #0091c7;
    padding: 10px 0 5px;
    font-weight: 700;
    text-align: left;
    width: 15%;
    margin-bottom: 15px;
}
.contenTitle{
    padding: 3px 0;
    border-bottom: 1px solid #0091c7;
}

`
export { CustomTitleModalStyle }

const ImportStyled = styled.div`
.boxInputCenter{
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 10px;
}

`
export { ImportStyled }